var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_563_38144)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.2986,
    cy: 12,
    r: 11.5,
    stroke: "#2A3790"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_563_38144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.35449 14.856H15.2019V13.6865H9.35449V14.856Z",
    fill: "#2A3790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2019 12.5171H9.35449V11.3477H15.2019V12.5171Z",
    fill: "#2A3790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35449 10.1783H11.6935V9.00879H9.35449V10.1783Z",
    fill: "#2A3790"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76985 5.5C8.3046 5.5 7.85841 5.68482 7.52943 6.0138C7.20044 6.34278 7.01563 6.78898 7.01562 7.25423V15.4406C7.01563 15.9059 7.20044 16.3521 7.52943 16.681C7.85841 17.01 8.3046 17.1948 8.76985 17.1948H15.7868C16.252 17.1948 16.6982 17.01 17.0272 16.681C17.3562 16.3521 17.541 15.9059 17.541 15.4406V9.59319C17.541 8.50761 17.1097 7.46649 16.3421 6.69887C15.5745 5.93125 14.5334 5.5 13.4478 5.5H8.76985ZM8.76985 6.66948H12.863V9.59319H16.3715V15.4406C16.3715 15.5957 16.3099 15.7444 16.2002 15.8541C16.0906 15.9637 15.9418 16.0254 15.7868 16.0254H8.76985C8.61477 16.0254 8.46604 15.9637 8.35638 15.8541C8.24672 15.7444 8.18511 15.5957 8.18511 15.4406V7.25423C8.18511 7.09914 8.24672 6.95041 8.35638 6.84075C8.46604 6.73109 8.61477 6.66948 8.76985 6.66948ZM14.0325 6.72796C14.4921 6.82211 14.9224 7.02529 15.2871 7.32039C15.6518 7.61549 15.9403 7.99388 16.1282 8.42371H14.0325V6.72796Z",
    fill: "#2A3790"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_563_38144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.298584)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_563_38144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(5.79858 5.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/documentIcon.38f2368c9980e570741b21267cfb8524.svg";
export { ForwardRef as ReactComponent };